import { logError } from "@faire/web--source/common/logging";
export var findItemByOptionTokenAndCustomizations = function(token, customizations, items) {
    var filteredItems = items.filter(function(item) {
        var _item_customizations;
        return item.product_option_token === token && item.customizations.length === customizations.size && ((_item_customizations = item.customizations) === null || _item_customizations === void 0 ? void 0 : _item_customizations.every(function(customization) {
            return customizations.get(customization.product_customization_token || "") === customization.value;
        }));
    });
    if (filteredItems.length > 1) {
        logError("Found multiple results when filtering by product option and customizations. productOptionToken=".concat(token, " productTokens=[").concat(items.map(function(item) {
            return item.product_token || "";
        }).join(", "), "]"));
    }
    return filteredItems[0];
};
